import { TimelineBatchesProps } from '@components/machines/components/timeline/components/TimelineBatches';
import { TIMELINE_LINE_CONFIG } from '@components/machines/components/timeline/constants';
import { calculateTimelineBatches, getTimelineFontStyles } from '@components/machines/components/timeline/helpers';

interface UseManageTimelineBatchesParams extends Pick<TimelineBatchesProps, 'batchesData' | 'rules' | 'events' | 'startTime'> {}
export const useManageTimelineBatches = ({ batchesData, events, rules, startTime }: UseManageTimelineBatchesParams) => {
  const batches = batchesData?.data || [];

  const { backgroundColor: timelineBg, borderRadius: timelineBorderRadius, height: timelineLineHeight } = TIMELINE_LINE_CONFIG;

  const { batchElements, totalDuration, unknownDuration } = calculateTimelineBatches({
    batches,
    groupedByBatchEvents: events.groupedByBatch,
    secondWidth: rules.secondWidth,
    timelineStart: startTime,
    batchStartField: 'startedOn',
    batchEndField: 'endedOn',
  });

  const unknownPercentage = totalDuration > 0 ? Math.round((unknownDuration / totalDuration) * 100) : 0;

  const { fontStylesWeb } = getTimelineFontStyles();

  return {
    batchElements,
    unknownPercentage,
    fontStylesWeb,
    timelineBg,
    timelineBorderRadius,
    timelineLineHeight,
  };
};